import _ from "lodash";

export const serviceById = state => serviceId => {
    return _.get(state.servicesById, serviceId)
}

export const serviceFormData = state => context => {
    return _.get(state.serviceFormContexts, [context, 'data'], {})
}

export const isServiceFormValid = state => (context) => {
    return _.get(state.serviceFormContexts, [context, 'formValid'], false)
}

export const serviceFormValidationErrors = state => context => {
    return _.get(state.serviceFormContexts, [context, 'errorMessagesByFields'],{})
}

export const serviceFormValidationErrorsByField = state => (context, fieldName) => {
    return _.get(state.serviceFormContexts, [context, 'errorMessagesByFields', fieldName], [])
}

export const progress = state => key => {
    return _.get(state.progress, key, false)
}